import { Component } from 'react';
import { func, object, node, number, string } from 'prop-types';

class Notification extends Component {
  static propTypes = {
    actionName: string,
    additionalMessage: string,
    children: node.isRequired,
    highlightedTitle: string,
    onActionClick: func,
    onCloseButtonClick: func,
    role: string,
    timeout: number,
    title: string.isRequired,
    transitionDuration: number,
    withIcon: object
  };

  state = {
    active: true
  }

  timer = null;

  componentDidMount = () => {  
    this.props.timeout && this.startTimer();
  }

  startTimer = () => {
    const { timeout } = this.props;

    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => { this.handleCloseButton(); }, timeout);
  }

  stopTimer = () => {
    clearTimeout(this.timer);
  }

  handleCloseButton = (e) => {
    const { onCloseButtonClick } = this.props;

    onCloseButtonClick && onCloseButtonClick(e);
    this.setState({ active: !this.state.active });
  }

  handleClickButton = (e) => {
    const { onActionClick } = this.props;

    onActionClick && onActionClick(e);
  }
}

export default Notification;



// WEBPACK FOOTER //
// ./src/uis/components/Notification/Notification.js